import { PRODUCT_NAME } from '../common';

const hasPermission = (permission, me, organizationId) =>
  me?.organizations?.find(({ id }) => id === organizationId)
    ?.products?.find(({ name }) => name === PRODUCT_NAME)
    ?.roles
    ?.some(({ permissions }) => permissions?.find(({ id }) => id === permission));

export default hasPermission;